module.exports = __webpack_public_path__ + "img/blog-04.70fae66f.jpg";